import { useFetch } from "../../hooks/useFetch";
import LoadSimple from "../LoadSimple";
import Modal from "react-modal";
import ModalDeleteCis from "./ModalDeleteCis";
import { useState, useEffect } from "react";
import ModalCisAfecta from "./ModalCisAfecta";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
import Action from "../Action";
import PruebaSSH from "./PruebaSSH";
import ModalUpdates from "./Software/ModalUpdates";
import ResetHost from "./Software/ResetHost";
const pingModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      background: '#363636',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width:'30%',
      height:'20%',
      padding:'20px'
    },
  };
  const addHostModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      background: '#ffffff !important',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width:'40%',
      height:'70%',
      padding:'20px'
    },
  };
  const configModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      background: '#363636',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width:'50%',
      height:'40%',
      padding:'20px'
    },
  };
const Actualizaciones = ({
    buscar_cis_history,
    handleChangEdit,
    cisSelected,
    server,
    languaje,
    handleShowPopup,
    mode
}) => {
  const [pingModalOpen, setPingModalOpen] =useState(false);
  const updateRequire=useFetch('cassia/windowsUpdate/windows-update/reboot-required/'+cisSelected.hostid,'','','GET',server)
  const availableUpdate=useFetch('cassia/windowsUpdate/windows-update/available-updates/'+cisSelected.hostid,'','','GET',server)
  const lastUpdate=useFetch('cassia/windowsUpdate/windows-update/latest-update/'+cisSelected.hostid,'','','GET',server)
  const [updateRunning,setUpdateRunning]=useState({
    data: [],
    loading: true,
    error: null,
  })
  function openPingModal() {
    setPingModalOpen(true);
  }

  function closePingModal() {
    setPingModalOpen(false);
  }
  const [configModalOpen, setConfigModalOpen] =useState(false);

  function openConfigModal() {
    setConfigModalOpen(true);
  }

  function closeConfigModal() {
    setConfigModalOpen(false);
  }
  const [addHostModalUpdateOpen, setAddHostUpdateModalOpen] =useState(false);
  function openAddHostUpdateModal() {
      
    //   console.log('open')
    setAddHostUpdateModalOpen(true);
    }

  function closeAddHostUpdateModal() {
   
    setAddHostUpdateModalOpen(false);
  }
  const [credentials,setCredentials]=useState({
      hostid: cisSelected.hostid,
      user: "string",
      pass_: "string"
    })
  const [dataSoft,setDataSoft]=useState({
    data: [],
    loading: true,
    error: null,
  })
  useEffect(()=>{
    search_softwares()
    search_status()
  },[])
  const search_status = () => {
    // setLoadingCis(true)
    setUpdateRunning({
      data: updateRunning.data,
      loading: true,
      error: updateRunning.error,
    });
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/windowsUpdate/windows-update/check-status/" +
            cisSelected.hostid,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();

          setUpdateRunning({
            data: data1,
            loading: false,
            error: updateRunning.error,
          });
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };

  const search_softwares = () => {
    // setLoadingCis(true)
    setDataSoft({
      data: dataSoft.data,
      loading: true,
      error: dataSoft.error,
    });
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/windowsUpdate/windows-update/update-history/" +
            cisSelected.hostid,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();

          setDataSoft({
            data: data1,
            loading: false,
            error: dataSoft.error,
          });
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };


  const [loading,setLoading]=useState(false)
  const Guardar=()=>{
    const data={
      "hostid": cisSelected.hostid,
      "user": credentials.user,
      "pass_": credentials.pass_
    }
    setLoading(true)
    const fetchDataPost = async () => {
      
   try {
     // console.log(localStorage.getItem('access_token'))
     const response = await fetch(server.url+'/api/v1/cassia/credentials', {
       method: 'POST',  
       headers: {
           'Content-Type': 'application/json',
           Authorization: `Bearer ${localStorage.getItem('access_token')}`,
         },
       body: JSON.stringify(data),
     });
     if (response.ok) {
       
       const data1 = await response.json();
       setLoading(false)
       handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['regEditCorr'])),'Credenciales Actualizadas', true)
       search_softwares()
       closeConfigModal()
     } else {
       const data1 = await response.json();
         handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),data1.detail, false)
         
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
          
      setLoading(false)
        // Manejo de errores
        
        console.error(error);
      }
    };

    fetchDataPost();
  }
  const handleChange=(e)=>{
    const {name,value}=e.target

    setCredentials((prevState)=>{
        return {
            ...prevState,
            [name]:value
        }
        
    })
  }
  // not_installed
  const {user,pass_}=credentials
  return (
    <>
    {(updateRequire.error!=true && availableUpdate.error!=true && lastUpdate.error!=true)?
      
        <div className="cont-app-list">
            <div className="compact-app-list" style={{display:'block'}}>
              
              <div className={"content-portafolio-head"+mode} style={{height:'30%'}}>
                <div className="cont_info_cis-gs" style={{height:'90%',width:'100%'}}>
                          <div className="top_info_cis-gs" style={{height:'100%'}}>
                          <div className="row_info_cis-gs" style={{height:'20%'}}>
                             
                              <div className="txt-info_cis-gs" style={{fontSize:'18px',position:'relative',left:'20px',color:'var(--third-color)'}}>{' Windows Update'}</div>
                            </div>
                            <div className="row_info_cis-gs">
                              <div className="title-info_cis-gs" style={{width:'25%',fontWeight:'unset',fontSize:'var(--font-size-small)'}} >
                                <div style={{ width: "80%", justifyContent: "start" }}>
                                  {capitalizeFirstLetter(lang[languaje]['reinicioRequerido'])}:
                                </div>
                              </div>
                              <div className="txt-info_cis-gs" style={{ width: "75%"}}>{(updateRequire.loading)?'...':(updateRequire.statusError?updateRequire.error:(lang[languaje][updateRequire.data.data.stdout]==undefined?updateRequire.data.data.stdout:lang[languaje][updateRequire.data.data.stdout]))}</div>
                            </div>
                            <div className="row_info_cis-gs" style={{height:'20%'}}>
                              <div className="title-info_cis-gs" style={{width:'25%',fontWeight:'unset',fontSize:'var(--font-size-small)'}}>
                                <div style={{ width: "80%", justifyContent: "start" }}>{capitalizeFirstLetter(lang[languaje]['updateAvailable'])}:</div>
                              </div>
                              <div className="txt-info_cis-gs"  style={{ width: "5%"}}>{(availableUpdate.loading)?'...':(availableUpdate.statusError?availableUpdate.error:availableUpdate.data.data.available_updates_count)}</div> 
                              <div className="txt-info_cis-gs btn-updates"   style={{ width: "20%"}}>
                                {(availableUpdate.loading)?'...':<Action disabled={false} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['seeUpdate'])}  action={()=>{openAddHostUpdateModal()}}/>}
                              
                              </div>
                            </div>
                            <div className="row_info_cis-gs">
                              <div className="title-info_cis-gs" style={{width:'25%',fontWeight:'unset',fontSize:'var(--font-size-small)'}}>
                                <div style={{ width: "80%", justifyContent: "start" }}>{capitalizeFirstLetter(lang[languaje]['lastUpdate'])}:</div>
                              </div>
                              <div className="txt-info_cis-gs" style={{ width: "75%"}}>{(lastUpdate.loading)?'...':(lastUpdate.statusError?lastUpdate.error:lastUpdate.data.data.latest_update.date)}</div>
                            </div>
                            <div className="row_info_cis-gs">
                                <div className="btn-updates" style={{display:'flex',width:'40%',height:'80%'}}>
                                <>
                                {
                                  (updateRunning.loading || availableUpdate.loading)?'...':((updateRunning.statusError || availableUpdate.statusError)?<div className="no-results" style={{color:'var(--red-alert)'}}>{'No se detecto una dependencia critica en el server:  PSWindowsUpdate'}</div>:
                                  (availableUpdate.data.data.available_updates_count>0?<Action disabled={(updateRunning.data.data.running_status==0?false:true)} origen='Azul' titulo={(updateRunning.data.data.running_status==0?capitalizeFirstLetter(lang[languaje]['saveUpdates']):'Actualizando')}  action={()=>{openPingModal()}}/>:''))
                                  
                                }
                                            
                                            {/* <Action disabled={false} origen='Red' titulo={capitalizeFirstLetter(lang[languaje]['resetHost'])}  action={()=>{openPingModal()}}/> */}
                                            </>
                                </div>
                            </div>
                            
                            </div>
                          </div>
            </div>
            <div className="content-portafolio" style={{height:'69%'}}>
            <div className="cont-table-portafolio">
      <div className={"head-table-portafolio"+mode}>
      <div className="compact-head-table-portafolio">
        <div className="field-head-table-cis field-medium" style={{width:'30%'}}>{capitalizeFirstLetter(lang[languaje]['fecha'])}</div>
        
        <div className="field-head-table-cis field-larger" style={{width:'70%'}}>{capitalizeFirstLetter(lang[languaje]['update'])}</div>
        
        </div>
      </div>
      <div className="body-table-cis-gs">
      <>
      <div className="cont-row-user-list">
      
        {(dataSoft.loading && !updateRunning.statusError && !updateRequire.statusError  && !availableUpdate.statusError) ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          
            (updateRunning.statusError || updateRequire.statusError  || availableUpdate.statusError)?
            <div className="no-results" style={{color:'var(--red-alert)'}}>{'No se detecto una dependencia critica en el server:  PSWindowsUpdate'}</div>:
            dataSoft.data.data.history
            .map((elemento, indice) => (
              <div
                className={"row-table-portafolio"+mode}
                key={1}
                // onClick={() => cisSelectRow(elemento)}
              >
                <div className="field-body-table-cis field-medium" style={{width:'30%'}}>
                  {elemento.date}
                </div>
                <div className="field-body-table-cis field-larger" style={{width:'70%'}}>
                  {elemento.title}
                </div>
                
               
                
                
              </div>
            ))
          
        )}
        {/* {dataUsers.loading == false && dataList.length == 0 ? (
          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}</div>
        ) : (
          ""
        )} */}
      </div>
      
    </>
      </div>
    </div>
            </div>                 

            
            </div>
        </div>:<div className="cont-app-list" style={{color:'red'}}>
            {capitalizeFirstLetter(lang[languaje]['errorCargaHost'])}
        </div>
}
        
        <Modal
        isOpen={addHostModalUpdateOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closeAddHostUpdateModal}
        style={addHostModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalUpdates search_status={search_status} server={server} handleShowPopup={handleShowPopup} cisSelected={cisSelected}  languaje={languaje}  mode={mode} closeAddHostModal={closeAddHostUpdateModal} ></ModalUpdates>
    </Modal>
    <Modal
        isOpen={pingModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closePingModal}
        style={pingModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ResetHost search_status={search_status} server={server} handleShowPopup={handleShowPopup} cisSelected={cisSelected}  languaje={languaje}  mode={mode} closePingModal={closePingModal} ></ResetHost>
    </Modal>
    </>
      
  );
};

export default Actualizaciones;
